'use client';
import { useParams } from 'next/navigation';
import { usePaymentLinkId } from '../../../hooks/usePaymentLinkId';
import { CheckoutHeading } from '../../checkoutHeading';
import { Summary } from '../../saleSummary';

export function CheckoutDetailsPage({
  accountName,
  displayName,
  organization,
  screen,
}: {
  accountName?: string;
  displayName?: string;
  organization?: string;
  screen: string;
}) {
  const params = useParams<{ paymentLinkId: string }>();
  const { data } = usePaymentLinkId(params.paymentLinkId);

  return (
    <aside className="w-full flex items-center justify-center pt-jade-200 md:pt-jade-600 pb-jade-0">
      <div className="flex w-full max-w-[416px] flex-col gap-jade-200 px-jade-200 md:max-w-[464px]">
        <CheckoutHeading
          accountName={accountName}
          displayName={displayName}
          organization={organization}
          email={data?.account_settings?.email}
          url={data?.layout_settings?.url}
          cnpj={data?.account_settings?.document}
        />
        <Summary screen={screen} />
      </div>
    </aside>
  );
}
